import * as _ from "lodash";
import {DateTime} from '../../utils/validators';

export const DATE_TIME_FORM_ADD_CHANGE = "DATE_TIME_FORM_ADD_CHANGE",
    RESET_DATE_TIME_FORM = 'RESET_DATE_TIME_FORM';

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

export interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            dirty?: boolean,
            readOnly?: boolean
        },
    }
}

const initialState: Form = {
    valid: false,
    data: {
        date: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        time: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        full_date: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
        county_time_zone : {
            required: false,
            added: false,
            value: null,
            error: null,
            dirty: false
        }
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);


const DateTimeForm = (state = initialState, action: Action) => {

    switch (action.type) {
        case DATE_TIME_FORM_ADD_CHANGE:
            return DateTime({...state.data}, action);
        case RESET_DATE_TIME_FORM:
            return _.cloneDeep(baseState);
        default:
            return state;
    }

};


export default DateTimeForm




